import InfoPopover from './InfoPopover';

function MultiSelect(props) {

	const handleSelect = (e) => {
		const selectedOptions = [];
		Object.keys(e.currentTarget.options).map(opt => {
			if (e.currentTarget.options[opt].selected) {
				selectedOptions.push(parseInt(e.currentTarget.options[opt].value))
			}
		});
		const newFilters = ['in', ['get', props.filterProperty], ['literal', selectedOptions]];
		props.setMultiSelectFilter(newFilters);
	}

	return (
		<div className="h-1/2">
			<div className="flex justify-center"><h2 className="italic font-bold text-center mb-2">{props.filterTitle}</h2><InfoPopover content="Filter the map by family. Ctrl click (PC) or Option click (Mac) to select multiple families." /></div>
			<label className="block text-left h-80">
				<select className="form-multiselect h-full w-full mt-1 border border-slate rounded-md" multiple onClick={handleSelect}>
					{props.options.map(opt => <option key={opt.id} value={opt.id} className="text-center" style={{"color": opt.color}}>{opt[props.filterFieldName]}</option>)}
				</select>
			</label>
			<hr className="border-b"/>
		</div>
	)
}

export default MultiSelect;
